<template>
  <v-row dense>
    <v-row dense>
      <v-col cols="3">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="tipoSolicitud" id="tipoSolicitud" :items="tiposSolicitud"
          :label="localizationFiltros.tipoSolicitud" :item-text="mostrarIdioma"
          item-value="codigoTipoSolicitud" :disabled="disabled" clearable />
      </v-col>
      <v-col cols="3">
        <!-- <v-autocomplete :no-data-text="$t('sinDatos')" v-model="promocion" id="promocion" :items="promociones"
          :label="localizationFiltros.promocion"
          item-text="name"
          item-value="id"
          :disabled="disabled"
          clearable
          @change="inmueble = null"
        />  -->
        <div @click="mostrarPopupPromociones()" >
            <v-autocomplete :no-data-text="$t('sinDatos')"
              v-model="promocion" id="promocion"
              :items="promociones"
              :label="localizationFiltros.promocion"
              item-value="id"
              item-text="name"
              :disabled="disabled"
              readonly
              multiple
              @change="popupPromociones($event)"
              >
            </v-autocomplete>
            </div>
      </v-col>
      <v-col cols="3">
        <v-row justify="space-between" align="center" no-gutters>

          <v-col cols="9" lg="10"
            v-if="inmuebles.length === 0"
            @click="promocion && promocion.length === 1 ? mostrarSeleccionarInmuebles = true : null"
            :style="promocion ? 'cursor: pointer !important' : ''"
          >
            <v-text-field :label="localizationFiltros.inmueble"
              :disabled="!promocion || disabled || promocion.length > 1" readonly />
          </v-col>
          <v-col cols="9" lg="10" v-else>
            <v-autocomplete :no-data-text="$t('sinDatos')" 
              :items="inmueblesSeleccionadosConId.length > 0 ? inmueblesSeleccionadosConId : []"
              v-model="inmueblesSeleccionadosConId" id="inmueblesSeleccionadosConId" 
              :disabled="!promocion || disabled || promocion.length > 1"
              :label="localizationFiltros.inmueble"  
              item-value="id"
              item-text="inmuebleDesc" 
              return-object multiple clearable 
              style="max-width: 350px;">
              
                  <template v-slot:selection="data">
                      <div v-if="inmuebles.length === 1" >
                          {{ limpiarNombre(data.item)}}
                      </div>
                      <div v-else-if="inmuebles.length < 5" >
                          {{ limpiarNombre(data.item) + ","}}
                      </div>
                      <div v-else-if="inmuebles.length >= 1 && data.index === 0">
                          {{ `${inmuebles.length} ${$t('popUpSeleccionarInmueble.itemsSeleccionados')}` }}
                      </div>
                  </template>
              </v-autocomplete>
          </v-col>
          <v-col>
            <v-btn color="primary" text icon large
              @click="mostrarSeleccionarInmuebles = true"
              :disabled="!promocion || disabled || promocion.length > 1">
              <v-icon>search</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="responsable" id="responsable" :items="responsables"
          :label="localizationFiltros.responsable"
          item-text="name"
          item-value="id"
          :disabled="disabled"
          clearable
        />
      </v-col>
      <v-col cols="3">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="cliente" id="cliente" :label="localizationFiltros.cliente" :items="clientes"
          item-text="name" item-value="id" clearable :disabled="disabled"/>
      </v-col>
      <v-col cols="3">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="clienteEspecial" id="clienteEspecial" :label="localizationFiltros.clienteEspecial"
          :items="clientesEspeciales" :item-text="mostrarIdioma" item-value="id"
          clearable :disabled="disabled" />
      </v-col>
      <v-col cols="3">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="urgencia" id="urgencia" :label="localizationFiltros.urgencia"
          :items="urgencias" :item-text="mostrarIdioma" item-value="id"
          clearable :disabled="disabled"/>
      </v-col>
      <v-col cols="3">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="estado" id="estado" :label="localizationFiltros.estado"
          :items="estados" :item-text="mostrarIdioma" item-value="id"
          clearable :disabled="disabled">
        </v-autocomplete>
      </v-col>
      <v-col cols="3">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="visita" id="visita" :label="localizationFiltros.tipoVisita"
          :items="tiposVisita" :item-text="mostrarIdioma" item-value="id"
          clearable :disabled="disabled" />
      </v-col>
      <v-col cols="3">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="localizacion" id="localizacion" :label="localizationFiltros.localizacion"
          :items="localizaciones" :item-text="mostrarIdioma" clearable
          :disabled="disabled" />
      </v-col>
      <v-col cols="3">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="oficio" id="oficio" :label="localizationFiltros.oficio"
          :items="oficios" :item-text="mostrarIdioma" item-value="id" clearable
          :disabled="disabled" @change="reloadSuboficios()" />
      </v-col>
      <v-col cols="3">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="suboficio" id="suboficio" :label="localizationFiltros.suboficio"
          :items="subOficios" :item-text="mostrarIdioma" item-value="id" clearable
          :loading="cargandoSuboficios"
          :disabled="disabled || !oficio || cargandoSuboficios" />
      </v-col>
      <v-col cols="3">
        <!-- v-if="promocion.length === 0" -->
        <v-autocomplete :no-data-text="$t('sinDatos')" v-if="promocion.length === 0 && (!oficio || oficio == null || oficio == '')" v-model="proveedor" id="proveedor" :label="localizationFiltros.proveedor"
          :items="providers" item-text="name" item-value="id"
          clearable :disabled="disabled" />
        <v-autocomplete :no-data-text="$t('sinDatos')" v-else v-model="proveedor" id="proveedor" :label="localizationFiltros.proveedor"
          :items="providersByPromoAndProf" item-text="name" item-value="id"
          clearable :disabled="disabled" />
      </v-col>
      <v-col cols="3">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="parte" id="parte" :label="localizationFiltros.parte"
          :items="orderTypes" :item-text="mostrarIdioma" item-value="id"
          clearable :disabled="disabled" />
      </v-col>
      <v-col cols="3">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="reclamacion" id="reclamacion" :label="localizationFiltros.reclamacion"
          :items="reclamaciones" :item-text="mostrarIdioma" item-value="id"
          clearable :disabled="disabled" />
      </v-col>
      <v-col cols="3">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="origen" id="origen" :label="localizationFiltros.origen"
          :items="origenes" :item-text="mostrarIdioma" item-value="id"
          clearable :disabled="disabled" />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="2" v-if="tipo !== 'estadisticasIncidencias'">
        <v-checkbox v-model="datosCliente" id="datosCliente"
          :label="localizationFiltros.datosCliente" color="primary" :disabled="disabled" @change="toogleHeaderClientes" />
      </v-col>
      <v-col cols="2">
        <v-checkbox v-model="revisada" id="revisada" :label="localizationFiltros.revisada" color="primary"></v-checkbox>
      </v-col>
      <v-col cols="2" v-if="tipo === 'relacionIncidencias' && notasActivas">
        <v-checkbox v-model="mostrarNotas" id="mostrarNotas"
          :label="localizationFiltros.mostrarNotas" color="primary" :disabled="disabled" @change="toogleHeaderNotas" />
      </v-col>
      <v-col cols="4" v-if="tipo === 'relacionIncidencias' && observacionesActivas">
        <v-checkbox v-model="mostrarObservaciones" id="mostrarObservaciones"
          :label="localizationFiltros.mostrarObservaciones" color="primary" :disabled="disabled" @change="toogleHeaderObservaciones" />
      </v-col>

    </v-row>
    <v-row dense>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="12">
            <span class="v-label theme--light">
              {{tipo !== 'relacionIncidencias' ? localizationFiltros.aperturaFin : localizationFiltros.apertura}}
            </span>
          </v-col>
          <v-col cols="12">
            <o-date-picker v-model="aperturaDesde" id="aperturaDesde" :label="localizationFiltros.desde"
              :disabled="disabled" :max="aperturaHasta" />
          </v-col>
          <v-col cols="12">
            <o-date-picker v-model="aperturaHasta" id="aperturaHasta" :label="localizationFiltros.hasta"
              :disabled="disabled" :min="aperturaDesde" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="12">
            <span class="v-label theme--light">
              {{localizationFiltros.fechaFinPrevista}}
            </span>
          </v-col>
          <v-col cols="12">
            <o-date-picker v-model="previstaDesde" id="previstaDesde" :label="localizationFiltros.desde"
              :disabled="disabled" :max="previstaHasta" />
          </v-col>
          <v-col cols="12">
            <o-date-picker v-model="previstaHasta" id="previstaHasta" :label="localizationFiltros.hasta"
              :disabled="disabled" :min="previstaDesde" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="12">
            <span class="v-label theme--light">
              {{localizationFiltros.cierre}}
            </span>
          </v-col>
          <v-col cols="12">
            <o-date-picker v-model="cierreDesde" id="cierreDesde" :label="localizationFiltros.desde"
              :disabled="disabled" :max="cierreHasta" />
          </v-col>
          <v-col cols="12">
            <o-date-picker v-model="cierreHasta" id="cierreHasta" :label="localizationFiltros.hasta"
              :disabled="disabled" :min="cierreDesde" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="12">
            <span class="v-label theme--light">
              {{localizationFiltros.reapertura}}
            </span>
          </v-col>
          <v-col cols="12">
            <o-date-picker v-model="reaperturaDesde" id="reaperturaDesde" :label="localizationFiltros.desde"
              :disabled="disabled" :max="reaperturaHasta" />
          </v-col>
          <v-col cols="12">
            <o-date-picker v-model="reaperturaHasta" id="reaperturaHasta" :label="localizationFiltros.hasta"
              :disabled="disabled" :min="reaperturaDesde" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="12">
            <span class="v-label theme--light">
              {{localizationFiltros.revisada}}
            </span>
          </v-col>
          <v-col cols="12">
            <o-date-picker v-model="revisadaDesde" id="revisadaDesde" :label="localizationFiltros.desde"
              :disabled="disabled" :max="revisadaHasta" />
          </v-col>
          <v-col cols="12">
            <o-date-picker v-model="revisadaHasta" id="revisadaHasta" :label="localizationFiltros.hasta"
              :disabled="disabled" :min="revisadaDesde" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3"/>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-row justify="space-between" align="end">
          <v-col cols="4">
            <v-row justify="space-between" align="end">
              <v-col cols="6">
                <v-btn @click="exportarExcel"
                  color="primary" :disabled="disabled">
                  {{localizationFiltros.excel}}
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn v-if="itramit" @click="exportarItramit"
                  color="primary" :disabled="disabled">
                  {{localizationFiltros.itramit}}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-btn-toggle v-model="toggle" id="toggle" @change="untoggle">
            <v-btn active-class="none" style="opacity: 1"
              :disabled="disabled" @click="borrarFiltros">
              {{localizationFiltros.borrar}}
            </v-btn>
            <v-btn active-class="none" style="opacity: 1"
              :disabled="disabled" @click="aplicarFiltros" color="primary">
              {{localizationFiltros.aplicar}}
            </v-btn>
          </v-btn-toggle>
        </v-row>
      </v-col>
    </v-row>
    <v-fade-transition>
      <custom-dialog  v-if="mostrarSeleccionarInmuebles"
        v-model="mostrarSeleccionarInmuebles" id="mostrarSeleccionarInmuebles"
        @aceptar="mostrarSeleccionarInmuebles = $event">
        <PopUpSeleccionarInmuebles  :yaSeleccionado="inmuebles" :promoId="(promocion.length > 0 ? promocion : '')"
          :multiple="true" @selected="inmuebles = $event" :incidencias="true" />
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog
        v-if="mostrarSeleccionarPromociones"
        v-model="mostrarSeleccionarPromociones" id="mostrarSeleccionarPromociones"
      >
        <PopUpSeleccionarPromociones
          :multiple="true"
          @selected="popupSeleccionarPromociones($event)"
        />
      </custom-dialog>
    </v-fade-transition>
  </v-row>
</template>

<script>
import PopUpSeleccionarInmuebles from '@/components/incidencias/PopUpSeleccionarInmuebles'
import { mapGetters, mapActions } from 'vuex'
import PopUpSeleccionarPromociones from '../incidencias/maestros/PopUpSeleccionarPromociones'

export default {
  components: {
    PopUpSeleccionarInmuebles,
    PopUpSeleccionarPromociones
  },
  props: {
    tipo: {
      type: String,
      default: 'relacionIncidencias'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    itramit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      cargandoSuboficios: false,
      toggle: null,
      mostrarSeleccionarInmuebles: false,
      tipoSolicitud: null,
      promocion: [],
      inmuebles: [],
      cliente: null,
      clienteEspecial: null,
      urgencia: null,
      estado: null,
      visita: null,
      localizacion: null,
      oficio: null,
      suboficio: null,
      proveedor: null,
      parte: null,
      reclamacion: null,
      datosCliente: false,
      aperturaDesde: null,
      aperturaHasta: null,
      previstaDesde: null,
      previstaHasta: null,
      cierreDesde: null,
      cierreHasta: null,
      reaperturaDesde: null,
      reaperturaHasta: null,
      responsable: null,
      revisadaDesde: null,
      revisadaHasta: null,
      revisada: null,
      origen: null,
      mostrarSeleccionarPromociones: false,
      mostrarNotas: false,
      mostrarObservaciones: false,
      origenes: [
        {
          id: '1',
          name: 'Portal del Cliente',
          translates: {
            spa: 'Portal del Cliente',
            eng: 'Customer portal',
            eus: 'Bezeroaren ataria'
          }
        },
        {
          id: '2',
          name: 'WEB',
          translates: {
            spa: 'WEB',
            eng: 'WEB',
            eus: 'WEB'
          }
        },
        {
          id: '3',
          name: 'APP',
          translates: {
            spa: 'APP',
            eng: 'APP',
            eus: 'APP'
          }
        },
        {
          id: '4',
          name: 'Prinex',
          translates: {
            spa: 'Prinex',
            eng: 'Prinex',
            eus: 'Prinex'
          }
        }
      ]
    }
  },
  created () {
    this.loadConfiguracion()
    this.getResponsables()
  },
  computed: {
    ...mapGetters({
      promocionesIdubapi: 'incidencias/getPromocionesIdubapi',
      tiposSolicitud: 'configuracion/getTiposSolicitud'
    }),
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    translates() {
      if (this.$store.state.tiposSolicitud.translates) {
        return this.$store.state.tiposSolicitud.translates;
      }
      return [];
    },
    localizationFiltros () {
      return this.$t('sectionInformes.filtros')
    },
    objFiltrosParaApi () {
      const idInmuebles = this.inmuebles.filter(x => x.inmuebleId !== null).map(x => {
        return x.inmuebleId
      })
      const idInmueblesEspeciales = this.inmuebles.filter(x => x.inmuebleEspecialId !== null).map(x => {
        return x.inmuebleEspecialId
      })
      return {
        InmuebleIdSelected: idInmuebles,
        InmuebleEspecialIdSelected: idInmueblesEspeciales,
        propertyDevelopment: this.promocion,
        Customer: this.cliente ? this.cliente : null,
        specialCustomer: this.clienteEspecial ? this.clienteEspecial : null,
        location: this.localizacion ? this.localizacion : null,
        urgencia: this.urgencia ? this.urgencia : null,
        tipo_visita: this.visita ? this.visita : null,
        status: this.estado ? this.estado : null,
        profession: this.oficio ? this.oficio : null,
        subprofession: this.suboficio ? this.suboficio : null,
        provider: this.proveedor ? this.proveedor : null,
        orderType: this.parte ? this.parte : null,
        complaint: this.reclamacion ? this.reclamacion : null,
        dc: this.datosCliente ? 1 : 0,
        mostrarNotas: this.mostrarNotas ? 1 : 0,
        mostrarObservaciones : this.mostrarObservaciones ? 1 : 0,
        export_csv: 0,
        codigoTipoSolicitud: this.tipoSolicitud,
        vencidas: this.tipo === 'relacionIncidencias' ? 'N' : 'S',
        finishDate1: this.tipo !== 'relacionIncidencias' ? this.aperturaDesde : '',
        finishDate2: this.tipo !== 'relacionIncidencias' ? this.aperturaHasta : '',
        openDate1: this.tipo === 'relacionIncidencias' ? this.aperturaDesde : '',
        openDate2: this.tipo === 'relacionIncidencias' ? this.aperturaHasta : '',
        previstaDate1: this.previstaDesde,
        previstaDate2: this.previstaHasta,
        closeDate1: this.cierreDesde,
        closeDate2: this.cierreHasta,
        reaperturaDate1: this.reaperturaDesde,
        reaperturaDate2: this.reaperturaHasta,
        promociones: this.promocionesIdubapi,
        responsable: this.responsable,
        revisada: this.revisada ? 1 : 0,
        revisadaDate1: this.revisadaDesde,
        revisadaDate2: this.revisadaHasta,
        origen: this.origen
      }
    },
    estados () {
      if (this.$store.state.incidencias.estados && this.$store.state.incidencias.estados.length > 0) {
        let estadosAux = []
        // let filterByEstado = (this.$store.state.configuracion.configuracion.configVistoBuenoCliente === false)?true:false;
        this.$store.state.incidencias.estados.forEach(estado => {
          // if((filterByEstado == false) || ((filterByEstado == true) && (estado.code != 41))) {
            estadosAux.push(estado)
          // }
        })
        return estadosAux.map(x => {
          return {
            ...x,
            text: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    clientes () {
      if (this.$store.state.incidencias.clientes) {
        return this.$store.state.incidencias.clientes
      }
      return []
    },
    clientesEspeciales () {
      if (this.$store.state.incidencias.clientesEspeciales) {
        return this.$store.state.incidencias.clientesEspeciales
      }
      return []
    },
    localizaciones () {
      if (this.$store.state.incidencias.roomPropTypes) {
        return this.$store.state.incidencias.roomPropTypes
      }
      return []
    },
    urgencias () {
      if (this.$store.state.incidencias.urgencias) {
        return this.$store.state.incidencias.urgencias
      }
      return []
    },
    tiposVisita () {
      if (this.$store.state.incidencias.tipoVisita) {
        return this.$store.state.incidencias.tipoVisita
      }
      return []
    },
    promociones () {
      if (this.$store.state.incidencias.promociones) {
        return this.$store.state.incidencias.promociones
      }
      return []
    },
    oficios () {
      if (this.$store.state.incidencias.oficios) {
        return this.$store.state.incidencias.oficios
      }
      return []
    },
    subOficios () {
      if (this.$store.state.incidencias.suboficios) {
        return this.$store.state.incidencias.suboficios
      }
      return []
    },
    providers () {
      if (this.$store.state.incidencias.providers) {
        return this.$store.state.incidencias.providers.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    providersByPromoAndProf () {
      if (this.$store.state.incidencias.providersByPropDevAndProf) {
        return this.$store.state.incidencias.providersByPropDevAndProf.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    reclamaciones () {
      if (this.$store.state.incidencias.complaintTypes) {
        return this.$store.state.incidencias.complaintTypes
      }
      return []
    },
    orderTypes () {
      if (this.$store.state.incidencias.orderTypes) {
        return this.$store.state.incidencias.orderTypes
      }
      return []
    },
    responsables () {
      let responsables = []
      if (this.$store.state.incidencias.responsables) {
        responsables =  this.$store.state.incidencias.responsables.map(x => {
          return {
            ...x,
            name: x.nombre + ' ' + x.apellidos
          }
        })
        return responsables.sort(function (a, b) {
          if (a.name < b.name) { return -1 }
          if (a.name > b.name) { return 1 }
          return 0
        })
      }
      return []
    },
    notasActivas () {
      return this.$store.state.configuracion.configuracion.PV_INFORME_NOTAS
    },
    observacionesActivas () {
      return this.$store.state.configuracion.configuracion.PV_INFORME_OBSERVACIONES
    },
    inmueblesSeleccionadosConId: {
      get () {
        return this.inmuebles.map(x => {
          return {
            ...x,
            inmuebleDesc: x.inmuebleId != null ? (x.uhedit + ' - ' + x.direccion) : (x.nomInmueble),
            id: x.inmuebleId != null ? x.inmuebleId: x.inmuebleEspecialId
          }
        })
      },
      set (value) {
        return value
      }
    }

  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getSuboficios: 'incidencias/getSuboficios',
      loadConfiguracion: 'configuracion/obtenerConfiguracion',
      getResponsables: 'incidencias/getResponsables',
      getProvidersByPropertyDevAndProfession: 'incidencias/getProvidersByPropertyDevAndProfession',

    }),
    mostrarIdioma (item) {
      if (item.translates && item.translates[this.usuario.idioma] && item.translates[this.usuario.idioma].length > 0 ) {
        return item.translates[this.usuario.idioma]
      } else {
        return item.name || item.description || item.text || ''
      }
    },
    async reloadSuboficios () {
      try {
        this.suboficio = undefined
        this.cargandoSuboficios = true
        await this.getSuboficios(this.oficio)
        if (this.suboficio && !this.suboficios.some(x => x.id === this.suboficio)) {
          this.suboficio = null
        }
      } catch (e) {
        console.log('error', e)
        this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
      }
      this.cargandoSuboficios = false
    },
    async untoggle () {
      await this.$nextTick()
      this.toggle = null
    },
    aplicarFiltros () {
      this.$emit('aplicar', this.objFiltrosParaApi)
    },
    borrarFiltros () {
      this.reiniciarFiltros()
      this.$emit('borrar', this.objFiltrosParaApi)
    },
    exportarExcel () {
      this.$emit('exportar', {
        ...this.objFiltrosParaApi,
        export_csv: 1
      })
    },
    exportarItramit () {
      this.datosCliente = true
      this.$emit('exportar', {
        ...this.objFiltrosParaApi,
        export_csv: 1,
        export_itramit: 1
      })
    },
    reiniciarFiltros () {
      this.tipoSolicitud = null
      this.promocion = []
      this.inmuebles = []
      this.cliente = null
      this.clienteEspecial = null
      this.urgencia = null
      this.estado = null
      this.visita = null
      this.localizacion = null
      this.oficio = null
      this.suboficio = null
      this.proveedor = null
      this.parte = null
      this.reclamacion = null
      this.datosCliente = false
      this.aperturaDesde = null
      this.aperturaHasta = null
      this.previstaDesde = null
      this.previstaHasta = null
      this.cierreDesde = null
      this.cierreHasta = null
      this.reaperturaDesde = null
      this.reaperturaHasta = null
      this.responsable = null,
      this.revisada = null,
      this.revisadaDesde,
      this.revisadaHasta = null,
      this.origen = null
    },
    limpiarNombre(item) {
      return item.inmuebleDesc.replace("<br>", " ")
    },
    mostrarPopupPromociones () {
      if ( this.mostrarSeleccionarPromociones === false ) {
        this.mostrarSeleccionarPromociones = true
      }
      else {
        this.mostrarSeleccionarPromociones = false
      }
    },
    popupSeleccionarPromociones (promocionesSelected) {
      this.inmueble = null
      if (promocionesSelected != null && promocionesSelected.length > 0) {
        console.log("popupSeleccionarPromociones")
        console.log(promocionesSelected.map( x => x.id))
        this.promocion =  promocionesSelected.map( x => x.id)
      } else {
        this.promocion = []
      }

    },
    toogleHeaderNotas () {
      this.$emit('toogleHeaderNotas', this.mostrarNotas)
    },
    toogleHeaderObservaciones () {
      this.$emit('toogleHeaderObservaciones', this.mostrarObservaciones)
    },
    toogleHeaderClientes() {
      this.$emit('toogleHeaderClientes', this.datosCliente)

    }
  },
  watch: {
    'promocion': function () {
      let items = {
        professionId: this.oficio,
        propertyDevelopmentId: ( this.promocion.length > 0 ? this.promocion : '')
      }
      this.getProvidersByPropertyDevAndProfession(items)
    },
    'oficio': function (){
      let items = {
        professionId: this.oficio == null ? null : this.oficio,
        propertyDevelopmentId: ( this.promocion.length > 0 ? this.promocion : '')
      }
      this.getProvidersByPropertyDevAndProfession(items)
    }
  }
}
</script>

